import { isAxiosError } from 'axios'
import axiosInstance, { getAccessToken } from './axiosInstance'

type AxiosBaseQueryProps = {
  baseUrl?: string
}

type AxiosInstanceProps = {
  url: string
  method: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'
  data?: any
  params?: any
  headers?: any
  responseType?: 'json' | 'blob' | 'text'
  includeAuth?: boolean
}

export interface IErrorResponse<T> {
  status: number | undefined
  data: T | null
}

const axiosBaseQuery =
  <T>({
    baseUrl = process.env.REACT_APP_BASE_URL ?? ''
  }: AxiosBaseQueryProps = {}) =>
  async ({
    url,
    method,
    data,
    params,
    headers = {},
    responseType = 'json',
    includeAuth = true
  }: AxiosInstanceProps) => {
    try {
      const result = await axiosInstance({
        url: baseUrl + url,
        method,
        data,
        params,
        headers: {
          ...headers,
          ...(includeAuth && getAccessToken()
            ? { Authorization: `Bearer ${getAccessToken()}` }
            : {})
        },
        responseType
      })

      return { data: result.data }
    } catch (error: unknown) {
      if (isAxiosError(error)) {
        return {
          error: {
            status: error.response?.status,
            data: error.response?.data || null
          } as IErrorResponse<T>
        }
      }
      return Promise.reject(new Error('An unexpected error occurred.'))
    }
  }

export default axiosBaseQuery
